<template>
  <div class="stats-grid">
    <div
      class="stat-card"
      v-for="(item, index) in totales"
      :key="index"
      :style="{ '--accent': accentColors[index % accentColors.length] }"
    >
      <div class="stat-icon">
        <b-icon :icon="item.icono" size="is-medium" />
      </div>
      <div class="stat-body">
        <span class="stat-label">{{ item.nombre }}</span>
        <span class="stat-value">
          <span
            v-if="
              typeof item.total === 'number' ||
              (!isNaN(Number(item.total)) &&
                item.total !== '' &&
                item.total !== null)
            "
          >
            {{ item.showDollarSign ? "$" : "" }}
            {{ formatoMonto(Number(item.total)) }}
          </span>
          <span v-else>{{ item.total }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Utiles from "../../Servicios/Utiles";

export default {
  name: "CartasTotales",
  props: ["totales"],

  data: () => ({
    accentColors: ["#14b8a6", "#22c55e", "#38bdf8", "#f59e0b", "#ef4444"],
  }),

  methods: {
    formatoMonto(valor) {
      return Utiles.formatoMonto(valor);
    },
  },
};
</script>

<style scoped>
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.stat-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-left: 3px solid var(--accent, var(--color-primary));
  border-radius: var(--radius-lg);
  padding: 1.1rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    background var(--transition), border-color var(--transition);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: var(--radius-sm);
  background: var(--color-surface2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent, var(--color-primary));
  flex-shrink: 0;
}

.stat-body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stat-label {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--color-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stat-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #e2e8f0;
  font-family: "JetBrains Mono", monospace;
  line-height: 1.3;
}
</style>
